import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// PitchesSection temporarily hidden while the right-column pitch-list UX is reworked.
// import { isPitchOrigin } from 'views_shared/app/javascript/constants/conversationOriginTypes';

import { expertUrl, productUrl } from 'views_shared/app/javascript/utils/urls';
import ProfileCard from './ProfileCard';
import TeammatesSection from './TeammatesSection';
// import PitchesSection from './PitchesSection';
import useProfileData from './useProfileData';

function ParticipantSection({ profile, conversation = null, showBorderBottom = true }) {
  const {
 bio, headline, hashtags, teamId,
} = useProfileData(profile.slug, profile.id);

  // const conversationPitchId = isPitchOrigin(conversation?.origin_type) ? conversation.origin_id : null;

  // For the promoted origin entity (Product or Expert at position 0 of participants),
  // route View Profile to its real page — products to /products/:slug, experts to /experts/:slug.
  // Regular participants fall through to the default profileUrl.
  let viewProfileUrl;
  if (conversation?.origin_product && profile.slug === conversation.origin_product.slug) {
    viewProfileUrl = productUrl;
  } else if (conversation?.origin_expert && profile.slug === conversation.origin_expert.slug) {
    viewProfileUrl = expertUrl;
  }

  return (
    <div className={classnames({ 'border-bottom': showBorderBottom })}>
      <ProfileCard
        profile={profile}
        bio={bio}
        headline={headline}
        hashtags={hashtags}
        viewProfileUrl={viewProfileUrl}
      />

      <TeammatesSection
        profileSlug={profile.slug}
        profileFirstName={profile.first_name || profile.name?.split(' ')[0] || ''}
        teamId={teamId}
      />

      {/* <PitchesSection profileSlug={profile.slug} conversationPitchId={conversationPitchId} /> */}
    </div>
  );
}

ParticipantSection.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    first_name: PropTypes.string,
    profile_image_url: PropTypes.string,
    title_at_workplace: PropTypes.string,
    type_of_profile: PropTypes.string,
  }).isRequired,
  conversation: PropTypes.shape({
    origin_type: PropTypes.string,
    origin_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    origin_expert: PropTypes.shape({ slug: PropTypes.string }),
    origin_product: PropTypes.shape({ slug: PropTypes.string }),
  }),
  showBorderBottom: PropTypes.bool,
};

export default ParticipantSection;
